import { isExpressionValueActive } from '../../../schema/expressions/evaluate/getExpressionValue';
import { useExpressionValue } from '../../../schema/expressions/render/hooks/useExpressionValue';
import { useWidgetScopeContext } from '../../../schema/form/fillable/WidgetScopeContext';
import { useWidgetComponentContext } from '../../../schema/widgets/context/WidgetComponentContext';
import { InfoIcon } from '../../../ui/info-icon/InfoIcon';
import { StyledRichTextAdvancedText } from '../../rich-text/style/StyledRichTextAdvancedText';
import { type IAdvancedRichTextItem } from '../IAdvancedRichText';
import { renderRichTextAdvancedNodes } from './renderRichTextAdvancedNodes';

export interface IRichTextConditionalProps {
  item: IAdvancedRichTextItem;
  index: number;
  inline?: boolean;
  hasCustomFont?: boolean;
  isInfoIcon?: boolean;
}

/**
 * Renderizza condizionalmente un nodo di RTE avanzato, in base alle
 * regole definite.
 */
export function RichTextConditional(props: IRichTextConditionalProps) {
  const { item, index, inline, hasCustomFont } = props;

  const { preview } = useWidgetComponentContext();

  const widgetScope = useWidgetScopeContext();
  // Creiamo un path "virtuale" per il nodo corrente;
  const basePath = `${widgetScope.prefix ?? ''}virtualNode`;

  const visible = useExpressionValue(basePath, item.rule, { skip: preview });
  if (!isExpressionValueActive(visible) && !preview) {
    return null;
  }

  if (props.isInfoIcon) {
    return <InfoIcon text={renderRichTextAdvancedNodes(item.text, preview)} />;
  }

  return (
    <StyledRichTextAdvancedText inline={inline} hasCustomFont={hasCustomFont}>
      {renderRichTextAdvancedNodes(item.text, preview)}
    </StyledRichTextAdvancedText>
  );
}
